import { API, ApiPrefixes } from "../api";

export const TransactionApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getStaffTransactionHistory: builder.query({
      query: ({
        page = 1,
        limit = 20,
        member_id,
        type,
        status,
        from_date,
        to_date,
        search,
      }) => {
        const params = new URLSearchParams({
          guard: "staff",
          page: page.toString(),
          limit: limit.toString(),
        });

        if (member_id) params.append("member_id", member_id);
        if (type) params.append("type", type);
        if (status) params.append("status", status);
        if (from_date) params.append("from_date", from_date);
        if (to_date) params.append("to_date", to_date);
        if (search) params.append("search", search);

        return {
          url: `${ApiPrefixes["adminTransactionHistories"]}?${params.toString()}`,
        };
      },
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, arg) => [
        { type: "staff-transaction-history", id: "list" },
      ],
      cacheStrategy: "cache-and-network",
    }),

    getTransactionDetailsById: builder.query({
      query: (recordId) => ({
        url: `${ApiPrefixes["adminTransactionHistories"]}/${recordId}/view?guard=staff`,
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, arg) => [
        { type: "staff-transaction-history", id: arg },
      ],
      cacheStrategy: "cache-and-network",
    }),
  }),
});

export const {
  useGetStaffTransactionHistoryQuery,
  useGetTransactionDetailsByIdQuery,
} = TransactionApi;

